import { Th, Thead, Tr } from "@chakra-ui/table";
import { Box, Flex } from "@chakra-ui/layout";
import { FaSortDown, FaSort, FaSortUp } from "react-icons/fa6";

const Header = ({ groups = [], ...props }) => {
  return (
    <Thead {...props}>
      {groups.map((group, rIdx) => (
        <Tr key={rIdx} {...group.getHeaderGroupProps()}>
          {group.headers.map((column, cIdx) => (
            <Th
              key={cIdx}
              whiteSpace="nowrap"
              isNumeric={column.isNumeric}
              {...column.getHeaderProps(column.getSortByToggleProps())}
            >
              <Flex
                alignItems="center"
                justifyContent={column.isNumeric ? "flex-end" : null}
              >
                <Box as="span">{column.render("Header")}</Box>
                {!column.disableSortBy && (
                  <Box pl="2">
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <FaSortUp />
                      ) : (
                        <FaSortDown />
                      )
                    ) : (
                      <FaSort />
                    )}
                  </Box>
                )}
              </Flex>
            </Th>
          ))}
        </Tr>
      ))}
    </Thead>
  );
};

export default Header;
